export function detectLanguageFromTitle(title: string): 'en' | 'fr' | 'unknown' {
  const lower = title.toLowerCase();
  const frenchIndicators = ['cuillère', 'gramme', 'litre', 'beurre', 'farine', 'œuf', 'lait', 'avec', 'dans', 'pour', 'de ', 'du ', 'des ', 'aux ', 'au ', 'en ', 'et ', 'la ', 'le ', 'les '];
  const englishIndicators = ['cup', 'tablespoon', 'butter', 'flour', 'egg', 'milk', 'with', 'and', 'the ', 'for ', 'roasted', 'baked', 'grilled', 'salad', 'soup', 'stew'];
  let fr = 0, en = 0;
  frenchIndicators.forEach(w => { if (lower.includes(w)) fr++; });
  englishIndicators.forEach(w => { if (lower.includes(w)) en++; });
  if (fr > en) return 'fr';
  if (en > fr) return 'en';
  return 'unknown';
}
